// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_RouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Unscramble from "../Unscramble/index.js";
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var ServingAreaId = function (x) {
    return x;
};
var asParamServingAreaId = Restaumatic_RouteAsURL.asParamInt;
var asJSONKeyServingAreaId = Data_Map_Serialized.asJSONKeyInt;
var udecodeServingAreaId = Unscramble.decodeInt1;
var showServingAreaId = Data_Show.showInt;
var ordServingAreaId = Data_Ord.ordInt;
var newtypeServingAreaId = {
    Coercible0: function () {
        return undefined;
    }
};
var fromJSONKeyServingAreaId = /* #__PURE__ */ (function () {
    return {
        fromJSONKey: new Unscramble.FromJSONKeyString(function (x) {
            var v = Data_Int.fromString(x);
            if (v instanceof Data_Maybe.Just) {
                return wrap(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Unscramble.decodingError("Invalid Int: " + show(x));
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.ServingAreaId (line 25, column 5 - line 27, column 61): " + [ v.constructor.name ]);
        })
    };
})();
var eqServingAreaId = Data_Eq.eqInt;
var encodeServingAreaId = Foreign_Generic_Class.intEncode;
var decodeServingAreaId = Foreign_Generic_Class.intDecode;
export {
    ServingAreaId,
    newtypeServingAreaId,
    showServingAreaId,
    eqServingAreaId,
    ordServingAreaId,
    encodeServingAreaId,
    decodeServingAreaId,
    udecodeServingAreaId,
    asParamServingAreaId,
    asJSONKeyServingAreaId,
    fromJSONKeyServingAreaId
};
